import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

interface SEOHeadProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  type?: 'website' | 'article' | 'product';
  noindex?: boolean;
}

const BASE_URL = 'https://nurtureskinstudio.co';
const DEFAULT_IMAGE = 'https://storage.googleapis.com/gpt-engineer-file-uploads/ki8llOiWTicJGVKizVBgA5z4JMg2/social-images/social-1768685358941-Screenshot 2026-01-15 200745.png';
const DEFAULT_DESCRIPTION = 'Discover authentic skincare products curated for your unique skin journey. Expert guidance, trusted global brands, and personalized skincare routines. Based in Lekki, Lagos.';
const SITE_NAME = 'Nurture Skin Studio';

export function SEOHead({
  title,
  description = DEFAULT_DESCRIPTION,
  keywords,
  image = DEFAULT_IMAGE,
  type = 'website',
  noindex = false,
}: SEOHeadProps) {
  const location = useLocation();
  
  // Normalize pathname: no trailing slashes, root becomes empty string
  const pathname = location.pathname === '/' 
    ? '' 
    : location.pathname.replace(/\/+$/, '');
  
  const canonicalUrl = `${BASE_URL}${pathname}`;
  const fullTitle = title
    ? `${title} | ${SITE_NAME}`
    : `${SITE_NAME} | Authentic Skincare Products in Lagos, Nigeria`;

  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="robots" content={noindex ? 'noindex, nofollow' : 'index, follow'} />
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:url" content={canonicalUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:site_name" content={SITE_NAME} />
      
      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:url" content={canonicalUrl} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
    </Helmet>
  );
}
